import { render, staticRenderFns } from "./templates.create.component.vue?vue&type=template&id=296a687a&scoped=true&"
import script from "./templates.create.component.vue?vue&type=script&lang=js&"
export * from "./templates.create.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296a687a",
  null
  
)

export default component.exports